import style from './style.m.less'
import { FC } from 'react'
import { IAttorneyData } from '../../../store/extension'
import { useTranslation } from 'react-i18next'
import { Alert } from 'antd'
import classNames from 'classnames'
import {getDaysRemaining, isExpired, shouldWarn} from "../../helpers";

interface IAttorneyBlock {
    attorney: IAttorneyData | null
    hasChanges?: boolean
}

const AttorneyBlock: FC<IAttorneyBlock> = ({ attorney, hasChanges = false }) => {
    const { t } = useTranslation()

    if (!attorney) {
        return <></>
    }

    const isAttorneyExpired = isExpired(attorney.validity_period, true)
    const isAttorneyExpiresIn30Days = shouldWarn(attorney.validity_period)

    return (
        <>
            <div className={classNames(
                style.documentData,
                hasChanges ? style.hasChanges : undefined
            )}>
                <div>
                    {`${t('editMyProfile.attorney.validityPeriod')}: до ${
                        attorney.validity_period
                    }`}
                </div>
                <div>{`${t('editMyProfile.attorney.number')}: ${attorney.number}`}</div>
                <div>{`${t('editMyProfile.attorney.internalNumber')}: ${
                    attorney.internal_number
                }`}</div>
                <div>{`${t('editMyProfile.attorney.companyInn')}: ${attorney.company_inn}`}</div>
                <div>{`${t('editMyProfile.attorney.naturalPersonInn')}: ${
                    attorney.natural_person_inn
                }`}</div>
            </div>
            {isAttorneyExpiresIn30Days && (<Alert
                className={style.alert}
                message={`Срок действия МЧД истекает через ${getDaysRemaining(attorney.validity_period)} дней`}
                type="warning"
                showIcon
            />)}
            {isAttorneyExpired && (<Alert
                className={style.alert}
                message={t('profile.attorneyIsExpired')}
                type="error"
                showIcon
            />)}
        </>
    )
}

export default AttorneyBlock
